module.exports = __webpack_public_path__ + "static/media/staffInfo.fd097db2.png";